// src/pages/NotFound/index.js
import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="404"
      subTitle="页面不存在"
      extra={
        <Button type="primary" className="themed-primary" onClick={() => navigate("/")}>
          回首页
        </Button>
      }
    />
  );
}
